<template>
  <v-list-item class="email">
    <v-list-item-content>
      <v-list-item-title>이메일</v-list-item-title>
      <div class="inner-content">
        <v-text-field
          solo
          placeholder="이메일"
          ref="refEmailId"
          :height="formHeight"
          v-model="userData.emailId"
        />
        <span>@</span>
        <!-- :readonly="userData.emailDomainType !== ''" -->
        <v-text-field
          solo
          ref="refEmailDomain"
          :height="formHeight"
          v-model="userData.emailDomain"
        />
      </div>
      <v-select
        solo
        required
        ref="refEmailDomainType"
        :items="itemsDomain"
        :height="formHeight"
        v-model="userData.emailDomainType"
        @change="domainTypeChange"
      />
    </v-list-item-content>
  </v-list-item>
</template>
<script>
const rulesService = require("@/utils/rules.js");
const formatService = require("@/utils/format.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      itemsDomain: formatService.domain(),
      emailIdRules: rulesService.emailIdRules(),
    };
  },
  methods: {
    domainTypeChange(e) {
      console.log("e", e);
      if (e === "") {
        this.$refs.refEmailDomain.focus();
      }
      this.userData.emailDomain = e;
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="">
</style>